export default __webpack_public_path__ + "static/media/icon-coin-fil.db28311b.svg";